import {Component} from "react";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../utilities/TabGrid";
import React from "react";
import {TopButtonPointEdit, TopButtonPointRemove} from "../../../../../componentsTopsa/buttons/TopButtons";

export default class EplatnosciTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
    }

    renderButtonyAkcji(cell, row) {
        return (
            <div>
                <TopButtonPointEdit onClick={() => {
                    this.props.handleEdytuj(row)
                }} titleContent={'Edytuj e-płatność'} disabled/>
                <TopButtonPointRemove onClick={() => {
                    this.props.handleUsun(row)
                }} titleContent={'Usuń e-płatność'} disabled/>
            </div>
        )
    }

    formatStatus(cell, row) {
        if (cell === 'TRUE') return <span style={{color: 'forestgreen'}} title={'Zapłacono'}><i className={'fa fa-check'}></i> {cell}</span>
        else return cell
    }

    render() {

        const options = {
            noDataText: 'Brak pasujących rekordów',
            sizePerPageList: [10, 15, 30, 50, 100],
            sizePerPage: this.props.ilosc,
            page: this.props.strona,
            onSizePerPageList: this.props.onSizePerPageList,
            onPageChange: this.props.onPageChange,
        };
        return (
            <div>
                <div style={{fontSize: "12px", color: "grey", fontStyle: "italic", clear: "both"}}>
                    <div className={"pull-right"}>
                        Ilość znalezionych rekordów: {this.props.pageable.totalElements}
                    </div>
                </div>
                <BootstrapTable data={this.props.data}
                                options={options}
                                pagination={!Boolean(this.props.czySzukanyCiag)}
                                hover
                                fetchInfo={{dataTotalSize: this.props.pageable.totalElements}}
                                remote={Boolean(this.props.czySzukanyCiag) ? false : true}
                >
                    <TableHeaderColumn dataField='id' isKey hidden={false} thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       dataSort={Boolean(this.props.czySzukanyCiag)}>ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='trDate' thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4} dataSort={Boolean(this.props.czySzukanyCiag)}
                                       filter={Boolean(this.props.czySzukanyCiag) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Data</TableHeaderColumn>
                    <TableHeaderColumn dataField='trId' thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} dataSort={Boolean(this.props.czySzukanyCiag)}
                                       filter={Boolean(this.props.czySzukanyCiag) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}>Kod
                        TPAY</TableHeaderColumn>
                    <TableHeaderColumn dataField='transakcja' thStyle={tabgrid.tg6} tdStyle={tabgrid.tg6}
                                       dataSort={Boolean(this.props.czySzukanyCiag)}
                                       filter={Boolean(this.props.czySzukanyCiag) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}>Kod
                        EBUS</TableHeaderColumn>
                    <TableHeaderColumn dataField='trEmail' thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4} dataSort={Boolean(this.props.czySzukanyCiag)}
                                       filter={Boolean(this.props.czySzukanyCiag) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}>Klient
                        email</TableHeaderColumn>
                    <TableHeaderColumn dataField='trAmount' thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort={Boolean(this.props.czySzukanyCiag)}
                                       filter={Boolean(this.props.czySzukanyCiag) ? {
                                           type: 'NumberFilter',
                                           delay: 500,
                                           placeholder: 'Szukaj'
                                       } : false}>Kwota</TableHeaderColumn>
                    <TableHeaderColumn dataField='trPaid' thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort={Boolean(this.props.czySzukanyCiag)}
                                       filter={Boolean(this.props.czySzukanyCiag) ? {
                                           type: 'NumberFilter',
                                           delay: 500,
                                           placeholder: 'Szukaj'
                                       } : false}>Zapł</TableHeaderColumn>
                    <TableHeaderColumn dataField='trStatus' thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort={Boolean(this.props.czySzukanyCiag)}
                                       filter={Boolean(this.props.czySzukanyCiag) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.formatStatus}>Status</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/eplatnosci/components/EplatnosciTable.js